<label *ngFor="let option of options" [class.active]="option.id === componentFormControl.value">
    <input type="radio" [formControl]="componentFormControl" [value]="option.id" />

    <img
        *ngIf="option.label === 'Black'"
        src="assets/images/model3-interior/model3-interior-black-refresh.jpg"
        alt=""
    />

    <img
        *ngIf="option.label === 'Black & White'"
        src="assets/images/model3-interior/model3-interior-black-and-white-refresh.jpg"
        alt=""
    />

    <div class="checkbox">
        <mg-ui-animated-check-dot [isChecked]="option.id === componentFormControl.value"> </mg-ui-animated-check-dot>
        <h4>
            {{
                { optionName: configurationOption.name, key: 'optionLabel', selectableOptionId: option.labelId }
                    | optionTranslation
                    | async
            }}
        </h4>
    </div>
</label>
